import TableAHSF from "../../Components/TableAHSF";



const FinancialSummary = (props) => {

    const culomEdite = ["email", "fullName"];
    const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

    const RequestAccessor = [
        {
            KeyName: "typeName",
            ShowStatus: true,
            NmaeColumn: "-",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "totalValue",
            ShowStatus: true,
            NmaeColumn: " الإجمالي",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
       
        {
            KeyName: "totalbrevousExchange",
            ShowStatus: true,
            NmaeColumn: "اجمالي الصرف حتى المرحلة السابقة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "currentExchange",
            ShowStatus: true,
            NmaeColumn: "اجمالي الصرف الحالي",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "remainingTotal",
            ShowStatus: true,
            NmaeColumn: "الاجمالي المتبقي",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        }
    ];
    const OtherMainBtns = [

    ];
    const PopupOPjectData = {
        isPopupOpenStatus: true,
        isPopupOpenFunction: () => {},
    
        componentBody: <></>,
        maxWidth: "500px",
    
        maxHeight: "800px",
        title: "الأهداف",
      };

    const RequestsColumns = [];
    //to render html after get data
    return (
        <>
            <TableAHSF
                culomEdite={culomEdite}
                uniqueValue={"bI_ObjectivesId"}
                valueButtonAction={"bI_ObjectivesId"}
                URL={`api/FinancialSummary/GetFinancialSummary`}
                UrlBody={{
                    specificOrMulti: true,
                    stageGuid: props.pR_ReportsStagesGuid,
                    reportGuid: props.reportId,
                    applicationInfoGuid: localStorage.getItem("aI_ApplicationInformationId_Manager")||localStorage.getItem("aI_ApplicationInformationId")   ,
                }}
                staticKeyEdite={staticKeyEdite}
                accessor={RequestAccessor}
                titelTable={"الملخص المالي"}
                selectRowNumber={true}
                checkBoksColumName="اختيار"
                sort={true}
                pagination={true}
                AppStatus={false}
                tableBtn={false}
                sortTable={true}
                keyNameSort={"dateCreate"}
                dateKey="dateCreate"
                dateformat="DD/MM/YYYY h:mm a"
                arrayNameSort={["applicationNumber"]}
                search={true}
                openPopupState={false}
                DropdownArrayFiltration={[]}
                DropdownFiltration={false}
                exportData={true}
                checkBoks={false}
                nameColumAction=""
                total={false}
                arrayButton={OtherMainBtns}
                ArrayNameDataColum={RequestsColumns}
                columnKeyNameArray={[
                    { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
                ]}
                PopupOPjectData={PopupOPjectData}
                popUpTitle={"معلومات الطلب"}
            // popUpBody2={[<ShowApplication addFun={true} />]}
            // popUpId2={"ShowApplicationpopUp"}
            // popUpBody2={[
            //   <ShowApplication columnId={columnId} list={list} addFun={false} />,
            // ]}
            // handleCloseModal={handleCloseModal}
            // showModal={showPopUp}
            />


        </>
    )
};
export default FinancialSummary;
